<template>
  <div :class="segundoPanel ? 'add-order-container segundo' : 'add-order-container'">
    <span class="container-icon" @click="isOpen = !isOpen">
      <b-icon-arrow-left-right class="icon" />
    </span>
    <div v-show="isOpen">
      <div class="" v-for="(action, index) in actions" :key="index + 'PActionsFloat'">
        <b-button
          v-b-tooltip.hover.d300="tooltip"
          variant="link"
          class="text mr-2"
          @click="click(action.action)"
        >
          {{ action.label }}
        </b-button>
        <span class="text separador_PActionsFloat" v-if="actions.length - 1 > index">|</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ILinksPActionsFloat } from "./pActionsFloat.types";

@Component
export class PActionsFloat extends Vue {
  @Prop({ required: true }) actions!: ILinksPActionsFloat[];
  @Prop({ required: false, default: false }) segundoPanel!: boolean;
  @Prop({ required: false, default: "" }) tooltip!: string;
  isOpen = true;

  click(accion: string): void {
    this.$emit("click", accion);
  }
}
export default PActionsFloat;
</script>
<style lang="scss" scoped>
.add-order-container {
  padding: 3px 16px 3px 3px;
  background-color: var(--amarillo-prosegur);
  border-top-left-radius: 2em;
  border-bottom-left-radius: 2em;
  position: fixed;
  right: 0;
  top: 5em;
  z-index: 2;
  &:hover .container-icon .icon {
    opacity: 1;
  }
  &.segundo {
    margin-top: -1.8em;
  }
  div {
    display: inline-block;
  }
  .container-icon {
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    background-color: white;
    border-radius: 100%;
    margin-right: 1em;
    height: 32px;
    width: 32px;
    .icon {
      margin-top: 4px;
      margin-left: 4px;
      font-size: 1.5rem;
      color: var(--secundario-prosegur-oscuro);
      opacity: 0.7;
    }
  }
  .text {
    vertical-align: middle;
    color: var(--secundario-prosegur-oscuro);
    padding: 0 0;
  }
}
.separador_PActionsFloat {
  margin-right: 8px;
}
</style>
